import { render } from "./Item4.vue?vue&type=template&id=01b2024c"
import script from "./Item4.vue?vue&type=script&lang=ts"
export * from "./Item4.vue?vue&type=script&lang=ts"
script.render = render

export default script